import { useMemo } from "react";

function useCameraCss(openedComponentDrawer, isParticipantExist) {
  return useMemo(() => {
    let mainWrapperCss, mainCameraScreenCss, otherCameraScreenCss;

    if (openedComponentDrawer.length > 0) {
      mainWrapperCss = "open-drawer-participent-section";
    } else {
      mainWrapperCss = "close-drawer-participent-section";
    }

    if (isParticipantExist) {
      if (openedComponentDrawer.length > 0) {
        mainCameraScreenCss = "open-drawer-candidates-box";
        otherCameraScreenCss = "open-drawer-interviewer-box";
      } else {
        mainCameraScreenCss = "close-drawer-candidates-box";
        otherCameraScreenCss = "flex-column close-drawer-interviewer-box";
      }
    } else {
      mainCameraScreenCss = "width-80 m-auto h-100";
      otherCameraScreenCss = "d-none";
    }

    return { mainWrapperCss, mainCameraScreenCss, otherCameraScreenCss };
  }, [openedComponentDrawer, isParticipantExist]);
}

export default useCameraCss;
